import type { ReactNode } from 'react';

export interface LegendItem {
  /** CSS colour — always a theme token, never a literal. */
  color: string;
  label: string;
}

/**
 * Series key for a widget. Rendered under the chart rather than inside it:
 * Recharts' built-in legend competes with the plot for vertical space, and
 * tiles are sized to their content.
 */
export function WidgetLegend({ items, note }: { items: LegendItem[]; note?: ReactNode }) {
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 pt-2 text-[11px] text-muted-foreground">
      {items.map((i) => (
        <span key={i.label} className="inline-flex items-center gap-1.5">
          <span
            aria-hidden
            className="size-2 shrink-0 rounded-[2px]"
            style={{ background: i.color }}
          />
          {i.label}
        </span>
      ))}
      {note ? <span className="ml-auto text-muted-foreground/70">{note}</span> : null}
    </div>
  );
}
